import { mapSkillStatus } from '../mapSkillStatus';

const buildScorePercentage = (score?: number) => (score && score !== 0 ? `${score}0%` : `${score}%`);
export const getLabelAndClass = (item: { skId: string; score?: number | null; submittedOn: Date | null }) => {
  let options: { className: string; label: string } = { className: '', label: '' };
  if (item.score !== null && item.score !== undefined) {
    options = {
      className: `${
        mapSkillStatus('', item.score).className === 'nc_perfect'
          ? 'nc_passed'
          : mapSkillStatus('', item.score).className
      } nc_skill-result-mini text-center mx-auto font-bold`,
      label: buildScorePercentage(item.score),
    };
  } else if (item.submittedOn) {
    options = { className: 'nc_passed nc_skill-result-mini text-center mx-auto font-bold', label: 'P' };
  } else {
    options = { className: 'nc_not-started nc_skill-result-mini text-center mx-auto font-bold', label: 'Not started' };
  }
  return (
    <span className={`${options.className} w-12 block`} style={{ maxWidth: '25rem' }}>
      {options.label}
    </span>
  );
};
